import Meta from 'src/components/meta/Meta';

const PdsMeta = () => <Meta
  title="Product Disclosure Statement (PDS) | BrickX"
  description="Before making any decision relating to BrickX or any product offered by BrickX you should read the Product Disclosure Statement (PDS)."
/>;

export default PdsMeta;
